(() => {
  const init = (root) => {
    if (!root || root.dataset.concernReady === 'true') return;

    const track = root.querySelector('[data-concern-track]');
    const prev = root.querySelector('[data-concern-prev]');
    const next = root.querySelector('[data-concern-next]');
    const progress = root.querySelector('[data-concern-progress]');
    if (!track) return;

    root.dataset.concernReady = 'true';

    const cardStep = () => {
      const card = track.querySelector('.lumina-concern__card');
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = max > 0 ? track.scrollLeft / max : 0;
      if (progress) progress.style.transform = `translateX(${ratio * 300}%)`;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };

    prev?.addEventListener('click', () => track.scrollBy({ left: -cardStep(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: cardStep(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-lumina-concern]').forEach(init);

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => initAll())
    : initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
